export default __webpack_public_path__ + "static/char-s-03-kr-0c861dda28ab2e8fb4bb842d80407342.png";